import api from '@shared/services/api.js';

export const getDashboards = async orgId => {
  return api.get(`/api/v1/organizations/${orgId}/dashboards`);
};
